import photo from "@assets/icons/photo.svg";
import WithModal, { CommonModalPropsI } from "@components/HOC/withModals";
import Button from "@components/global/new/Button/Button";
import Error from "@components/global/new/Error/Error";
import Field from "@components/global/new/Field/Field";
import Title from "@components/global/new/Title/Title";
import { MODALS_ENUM } from "@constants/Modals";
import { useIntl } from "react-intl";
import useAddSparePartsTypesModalControl, { AddSparePartsTypesOnSuccess } from "./AddSparePartsTypesModal.control";
import { Upload, Image } from "antd";
import { LoadingOutlined, UploadOutlined } from "@ant-design/icons";

const { Dragger } = Upload;

interface IAddSparePartsTypesModalProps extends CommonModalPropsI {
	onSuccess: AddSparePartsTypesOnSuccess;
}

interface UploadButtonProps {
	caption: string;
}

function UploadButton({
	caption
}: UploadButtonProps): JSX.Element {
	return (
		<button
			style={{
				border: 0,
				background: 'none',
			}}
			type="button"
		>
			<UploadOutlined />
			<div
				style={{
					marginTop: 8,
				}}
			>
				{caption}
			</div>
		</button>
	);
}

function AddSparePartsTypesModal({
	onSuccess,
	handleClose
}: IAddSparePartsTypesModalProps): JSX.Element {

	const { formatMessage } = useIntl();
	const control = useAddSparePartsTypesModalControl(
		onSuccess,
		handleClose
	);

	return (
		<div className="modal__add-spareparts">
			<Title>
				{formatMessage({ id: "spareparts.modal.add_type.title" })}
			</Title>
			<form className="content" onSubmit={control.submit}>
				<Field
					id='name'
					name={formatMessage({ id: "spareparts.modal.add_type.name" })}
					placeholder='Name'
					type='text'
					defaultValue={""}
				/>
				<br />
				{/* <Dragger
					accept='.jpg,.jpeg,.png,.webp,.gif'
					onRemove={(e) => { console.log("onRemove", e); }}
					customRequest={(e) => { console.log("customRequest", e); }}
					onPreview={(e) => { console.log("onPreview", e); }}
					fileList={[]}
					maxCount={1}
					showUploadList={false}
					name='File'
				>
					<p className='ant-upload-drag-icon'>
						<InboxOutlined rev={undefined} />
					</p>
					<p className="">
						{formatMessage({ id: "modal.upload_photo.drop_text" })}
					</p>
					<p className="">jpg, jpeg, png, webp, gif</p>
				</Dragger> */}

				<Upload
					listType='picture-card'
					fileList={control.files}
					maxCount={1}
					onRemove={(file) => {
						control.setFiles([]);
					}}
					beforeUpload={(file) => {
						return false;
					}}
					onPreview={control.handlePreview}
					onChange={({ fileList: newFileList }) => {
						control.setFiles(newFileList);
					}}
				>
					<UploadButton
						caption={
							control.files.length === 0 ? "Upload" : "Change"
						}
					/>
				</Upload>
				{control.previewImage && (
					<Image
						wrapperStyle={{
							display: 'none',
						}}
						preview={{
							visible: control.previewOpen,
							onVisibleChange: (visible) => control.setPreviewOpen(visible),
							afterOpenChange: (visible) => !visible && control.setPreviewImage(''),
						}}
						src={control.previewImage}
					/>
				)}
				<br />
				{control.errors && <Error errors={control.errors} />}
				<br />
				<Button type='submit' disabled={control.isLoading}>
					{control.isLoading && <LoadingOutlined />}
					{formatMessage({ id: "common.save" })}
				</Button>
			</form>
		</div>
	);
}

export default WithModal(MODALS_ENUM.ADD_SPAREPARTS_TYPES, AddSparePartsTypesModal);